import { UserEvents, trackEvent } from "@/analytics";

import DownloadOnTheAppStore from "../common/icons/DownloadOnTheAppStore";
import Image from "next/image";
import Link from "next/link";
import { SocialMediasRow } from "@/components/common/SocialMediaIcons";
import logoWithIconWhite from "@/public/resources/punchupLogoIconWhite.svg";

const PUNCHUP_APPLE_APP_STORE_URL =
  "https://apps.apple.com/us/app/punchup-for-artists-and-fans/id6741537144";

export default function Footer() {
  return (
    <footer className="flex flex-col flex-wrap justify-between px-4 py-12 bg-slate-gray-900 md:flex-row md:py-8 md:px-14 lg:py-12 lg:px-20 gap-y-6">
      <div className="flex flex-col w-full gap-3">
        <div className="flex flex-row items-center justify-between w-full">
          <Link href="/" aria-label="Home">
            <Image
              src={logoWithIconWhite}
              alt="Punchup"
              aria-label="Punchup logo"
              width={189}
              height={24}
              className="h-[24px] w-auto max-w-full"
            />
          </Link>
          <SocialMediasRow
            label="Punchup"
            medias={[
              {
                type: "Twitter",
                link: "https://twitter.com/punchuplive",
              },
              {
                type: "Instagram",
                link: "https://www.instagram.com/punchuplive/",
              },
              {
                type: "Facebook",
                link: "https://www.facebook.com/PunchUplive-110636622055683",
              },
              {
                type: "TikTok",
                link: "https://www.tiktok.com/@punchuplive",
              },
            ]}
          />
        </div>
        <div className="flex flex-row items-start gap-x-2">
          <Link
            className="p-0 border-none cursor-pointer bg-none"
            aria-label="Download Punchup on the App Store"
            onClick={() =>
              trackEvent(UserEvents.CLICKED_DOWNLOAD_ON_THE_APP_STORE)
            }
            href={PUNCHUP_APPLE_APP_STORE_URL}
            target="_blank"
          >
            <DownloadOnTheAppStore />
          </Link>
        </div>
      </div>
      <div className="inline-flex flex-row flex-wrap items-start justify-center w-full text-white text-opacity-75 md:justify-end gap-x-1 md:items-end">
        <p className="whitespace-nowrap">© 2026 Punchup.</p>
        <p className="whitespace-nowrap">All rights reserved.</p>
        <div className="flex flex-row gap-x-2">
          <Link href="/tos" aria-label="Terms of Service">
            <div className="inline underline">Terms</div>
          </Link>
          <Link href="/privacy" aria-label="Privacy Policy">
            <div className="inline underline">Privacy</div>
          </Link>
          <Link href="/anti-spam" aria-label="Anti-Spam Policy">
            <div className="inline underline">Anti-Spam</div>
          </Link>
        </div>
      </div>
    </footer>
  );
}
